import { render, staticRenderFns } from "./InvoiceSummary.vue?vue&type=template&id=0651b574&scoped=true"
import script from "./InvoiceSummary.vue?vue&type=script&lang=ts"
export * from "./InvoiceSummary.vue?vue&type=script&lang=ts"
import style0 from "./InvoiceSummary.vue?vue&type=style&index=0&id=0651b574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0651b574",
  null
  
)

export default component.exports